import {
  DEFAULT,
  PERCEPTUAL,
  POINT_IN_TIME,
  PRE_POST,
  DISTRIBUTION,
  TREND,
  URL_BY_BRAND,
  URL_BY_MARKET,
  URL_BY_SEGMENT,
} from "@/constant/constantsThrougoutProject";
import { ROUTES_CHILDREN_LOOKUP } from "@/routes/routes";
import { capitalizeFirstLetter } from "@/utils/stringUtility";

export const disabledExportOptions: any = {
  [URL_BY_BRAND]: {
    [POINT_IN_TIME]: {
      [PERCEPTUAL]: ["png", "pdf", "xlsx"],
      [DISTRIBUTION]: ["png", "pdf"],
      [DEFAULT]: ["png", "pdf"],
    },
    [TREND]: {
      [DEFAULT]: ["png", "pdf"],
    },
    [PRE_POST]: {
      [DEFAULT]: ["png", "pdf"],
    },
  },
  [URL_BY_MARKET]: {
    [POINT_IN_TIME]: {
      [DISTRIBUTION]: ["png", "pdf"],
      [DEFAULT]: ["png", "pdf"],
    },
    [TREND]: {
      [DEFAULT]: ["png", "pdf"],
    },
    [PRE_POST]: {
      [DEFAULT]: ["png", "pdf"],
    },
  },
  [URL_BY_SEGMENT]: {
    [POINT_IN_TIME]: {
      [DISTRIBUTION]: ["png", "pdf"],
      [DEFAULT]: ["png", "pdf"],
    },
    [TREND]: {
      [DEFAULT]: ["png", "pdf"],
    },
    [PRE_POST]: {
      [DEFAULT]: ["png", "pdf"],
    },
  },
};

export const MODE_LABEL_MAP: Record<string, string> = {
  [POINT_IN_TIME]: "Point In Time",
  [TREND]: "Trends",
  [PRE_POST]: "Pre Post",
  DISTRIBUTION: "Profile",
};

/**
 * Derives a file name for an export based on the current pathname, mode, and
 * format. Used by the V2 export path (non-exclusive-questions modules).
 */
export function getExportFileName(
  pathname: string,
  mode: string,
  format: string,
): string {
  const ext = format === "pptx" ? ".pptx" : ".xlsx";

  if (pathname.includes("exclusivequestions")) {
    if (pathname.includes(URL_BY_SEGMENT)) {
      return `Question Segment Response${ext}`;
    }
    if (pathname.includes(URL_BY_BRAND)) {
      return `Question Brand Response${ext}`;
    }
  }

  const currentPathDetail = ROUTES_CHILDREN_LOOKUP[pathname];
  if (typeof currentPathDetail?.id === "string") {
    const routeLabel = currentPathDetail.id
      .split("/")
      .map((part: string) => capitalizeFirstLetter(part))
      .join(" ");
    const modeLabel = MODE_LABEL_MAP[mode] ?? MODE_LABEL_MAP[POINT_IN_TIME];
    return `${routeLabel} ${modeLabel}${ext}`;
  }

  return `export${ext}`;
}
